export default {
  shared: {
    appVersion: "Versione app",
    brand: "Marca",
  },
  assignBeforePairing:
    "Assegna questo dispositivo a una struttura prima di collegare un lettore",
  deviceRevoked: "Dispositivo revocato",
  deviceReactivated: "Dispositivo riattivato",
  deviceShelved: "Dispositivo in magazzino",
  deviceUnshelved: "Dispositivo rimesso in campo",
  credentialsRegenerated: "Credenziali rigenerate",
  kioskAssigned: "Dispositivo assegnato con successo",
  readerUpdated: "Lettore aggiornato",
  deviceRenamed: "Stanza aggiornata",
  changeRoomTitle: "Cambia stanza",
  addRoomTitle: "Aggiungi stanza",
  changeRoomCurrentLabel: "Stanza attuale",
  changeRoomNewLabel: "Nuovo nome stanza",
  changeRoomPlaceholder: "es. 231H",
  changeRoomNoRoom: "Nessuna stanza",
  changeRoomUnchanged: "Inserisci un nome diverso per continuare",
  changeRoomConfirm: "Continua",
  changeRoomRemove: "Rimuovi stanza",
  deviceGoogleAccountUpdated: "Account Google aggiornato",
  deviceNotesUpdated: "Note aggiornate",
  deviceInstalledOnUpdated: "Data di installazione aggiornata",
  page: {
    kpiTotal: "Dispositivi attivi",
    kpiTotalHint: "Esclusi quelli in magazzino",
    kpiOnline: "Online",
    kpiOnlineHint: "Telemetria completa nelle ultime 3 h",
    kpiIncomplete: "Configurazione incompleta",
    kpiIncompleteHint: "Manca abbinamento, lettore o struttura",
    kpiShelved: "In magazzino",
    kpiShelvedHint: "Non in campo",
    title: "Gestione dispositivi",
    subtitle: "Gestisci i dispositivi delle strutture",
    newDevice: "Nuovo dispositivo",
    tabDevices: "Dispositivi",
    tabPresets: "Preset dispositivo",
    searchPlaceholder: "Cerca per nome, codice, struttura o altro…",
    filterActiveLabel: "Attivo",
    filterActiveAll: "Tutti",
    filterActiveActive: "Attivi",
    filterActiveInactive: "Inattivi",
    filterSetupLabel: "Configurazione",
    filterSetupAll: "Tutti",
    filterSetupComplete: "Completi",
    filterSetupIncomplete: "Richiede attenzione",
    filterSetupRevoked: "Revocati",
    filterShelvedLabel: "Magazzino",
    filterShelvedAll: "Tutti",
    filterShelvedInService: "In campo",
    filterShelvedOnly: "In magazzino",
    filterTelemetryLabel: "Stato telemetria",
    filterTelemetryAll: "Tutti",
    filterTelemetryGray: "Non associato",
    filterTelemetryGreen: "Completa",
    filterTelemetryYellow: "Incompleta",
    filterTelemetryRed: "Nessun dato (> 3 h)",
    filterAppVersionAny: "Qualsiasi",
    filterAppVersionCount: "{{count}} selezionate",
    filterIncompleteMissingLabel: "Motivo",
    filterIncompleteMissingAny: "Qualsiasi",
    filterIncompleteMissingCount: "{{count}} selezionati",
    filterAttentionNoTelemetry: "Nessuna telemetria",
    filterAttentionOutdatedApp: "App obsoleta",
    filterMissingBinding: "Manca chiave software",
    filterMissingReader: "Manca lettore",
    filterMissingStructure: "Manca struttura",
    telemetryTooltipGray: "Mai connesso o non associato",
    telemetryTooltipGreen: "Telemetria completa",
    telemetryTooltipYellow: "Telemetria incompleta",
    telemetryTooltipRed: "Nessuna telemetria (> 3 h)",
    alertLowBattery: "Batteria scarica ({{level}}%)",
    alertWifiWeak: "Wi-Fi assente o segnale debole",
    inUseWarningTitle: "Richiede attenzione",
    inUseWarningStaleTelemetry: "Nessuna telemetria nelle ultime 24 ore",
    inUseWarningOutdatedAppVersion: "Versione app precedente a {{version}}",
    inUseWarningDeviceLowBattery: "Batteria del tablet scarica",
    inUseWarningReaderLowBattery: "Batteria del lettore scarica",
    inUseWarningMissingReader: "Nessun lettore collegato",
    inUseWarningMissingStructure: "Nessuna struttura assegnata",
    inUseWarningMissingRoom: "Nessuna stanza impostata",
    inUseCheckTelemetry: "Telemetria",
    inUseCheckAppVersion: "Versione app",
    inUseCheckDeviceBattery: "Batt. tablet",
    inUseCheckReaderBattery: "Batt. lettore",
    inUseCheckReader: "Lettore",
    inUseCheckStructure: "Struttura",
    inUseCheckRoom: "Stanza",
    inUseCheckOk: "OK",
    inUseCheckUnknown: "Sconosciuto",
    setupBadgeIncomplete: "Incompleto",
    setupBadgeRevoked: "Revocato",
    setupBadgeIncompleteTooltipTitle: "Manca ancora:",
    setupBadgeIncompleteTooltipDesc:
      "Questo dispositivo non può accettare pagamenti finché la configurazione non è completa.",
    setupBadgeRevokedTooltip: "Questo dispositivo è stato revocato",
    setupMissingBinding: "Associazione chiave software",
    setupMissingBindingDesc:
      "Il tablet deve accedere almeno una volta con la propria chiave software.",
    setupMissingPairing: "Collegamento lettore di pagamento",
    setupMissingPairingDesc:
      "È necessario collegare un lettore di pagamento a questo tablet per elaborare i pagamenti con carta.",
    setupMissingAssignment: "Assegnazione a struttura",
    setupMissingAssignmentDesc:
      "Il dispositivo deve essere assegnato a una struttura host.",
    colDevice: "Stanza",
    colSerial: "S/N",
    colGoogleAccount: "Account Google",
    colFreekioskUnlock: "Sblocco FK",
    colReader: "Lettore",
    colHouse: "Struttura",
    colLastTelemetry: "Ultima telemetria",
    colLastInteraction: "Ultima interazione",
    colInstalledOn: "Installato il",
    colInUse: "In campo",
    colActions: "Azioni",
    selectRow: "Seleziona {{name}}",
    selectAllFiltered: "Seleziona tutti i {{count}} filtrati",
    exportCsv: "Esporta CSV",
    emptySearch: "Nessun dispositivo corrisponde alla ricerca.",
    emptyDefault: "Nessun dispositivo. Creane uno per iniziare.",
    readerPair: "Collega",
    readerOpenTitle: "Vai al lettore",
    readerUnpairTitle: "Scollega lettore",
    readerUnpairConfirm:
      "Scollegare questo lettore dal tablet? L'abbinamento SumUp rimane; i pagamenti resteranno disabilitati finché non lo colleghi di nuovo.",
    readerUnpaired: "Lettore scollegato",
    houseOpenTitle: "Vai alla struttura",
    houseRemoveTitle: "Rimuovi struttura dal dispositivo",
    houseRemoveConfirm:
      "Rimuovere «{{name}}» da questo dispositivo? Diventerà non assegnato.",
    houseRemoved: "Struttura rimossa",
    structureLeaveIntro:
      'Lasciando «{{name}}» verrà cancellata l’occupazione attiva di questo tablet.',
    structureLeaveCurrentHeading:
      "Ospiti attuali (soggiorno terminato, resta in cronologia)",
    structureLeaveFutureHeading: "Ospiti futuri (eliminati del tutto)",
    structureLeaveCurrentNote:
      "I soggiorni attuali terminano ora e restano nella cronologia di questa struttura.",
    structureLeaveFutureNote:
      "I soggiorni futuri vengono rimossi e non possono essere ripristinati.",
    structureLeaveEmpty: "Nessun ospite attuale o futuro su questo tablet.",
    structureLeaveLoading: "Controllo ospiti…",
    assignLeaveIntro:
      'Questo tablet lascia «{{name}}». L’occupazione attiva verrà cancellata prima di assegnare la nuova struttura.',
    roomChangeTitle: "Cambiare stanza?",
    roomChangeIntro:
      "Questo tablet ha ospiti attuali o futuri. Scegli cosa farne.",
    roomChangeNewLabel: "Nuova stanza:",
    roomChangeCurrentHeading: "Ospiti attuali",
    roomChangeFutureHeading: "Ospiti futuri",
    roomChangeTransferHelp:
      "Trasferisci: mantieni gli ospiti su questo tablet con il nuovo nome stanza.",
    roomChangeDiscardHelp:
      "Scarta: termina gli ospiti attuali (cronologia conservata) ed elimina i soggiorni futuri.",
    roomChangeTransfer: "Trasferisci ospiti",
    roomChangeDiscard: "Scarta occupazione",
    assign: "Assegna",
    moreActionsTitle: "Altre azioni",
    regenerateConfirm:
      "Rigenerare la password di «{{name}}»? Le sessioni tablet esistenti non saranno più valide.",
    revokeConfirm:
      "Revocare le credenziali di «{{name}}»? Il tablet verrà disconnesso e non potrà più accedere finché non lo riattivi.",
    credentialModalTitle: "Credenziali rigenerate",
    credentialModalDesc:
      "La password è stata rigenerata. Salva subito queste credenziali: la password viene mostrata una sola volta.",
    statusPartial: "Parzialmente configurato",
    assignModalTitle: "Assegna dispositivo",
    assignModalIntro: "Assegna {{name}} a un host e a una struttura.",
    selectHostStep: "1) Seleziona host",
    selectHouseStep: "2) Seleziona struttura",
    searchHostsPlaceholder: "Cerca host…",
    searchHousesPlaceholder: "Cerca strutture…",
    searchHousesDisabledPlaceholder: "Prima seleziona un host…",
    noHostsFound: "Nessun host trovato.",
    pickHostForHouses: "Scegli un host per vedere le sue strutture.",
    noHousesFound: "Nessuna struttura trovata.",
    noAddressSet: "Nessun indirizzo",
    assignedDevicesLabel: "Dispositivi assegnati:",
    assignSubmit: "Assegna",
    otherInfoTitle: "Altre informazioni sul dispositivo",
    fieldRoomName: "Stanza",
    fieldKioskCode: "Codice dispositivo",
    fieldSerialNumber: "Numero di serie",
    fieldSoftwareId: "ID software",
    fieldGoogleAccount: "Account Google",
    fieldReaderId: "ID lettore",
    fieldDisplayInches: "Pollici display",
    fieldResolution: "Risoluzione",
    fieldAndroidVersion: "Versione Android",
    valueAppVersionUnknown: "Sconosciuta",
    valueAppVersionLegacy: "<=0.4.0",
    valueFreekioskUnlockUnavailable: "—",
    editNotesTitle: "Note",
    editInstalledOnTitle: "Data di installazione",
    insertInstalledOn: "Inserisci data",
    notesPlaceholder: "Aggiungi una nota…",
    fieldLastTelemetryReport: "Ultima telemetria ricevuta",
    sectionTelemetryData: "Dati telemetria",
    sectionTelemetryDeviceStatus: "Stato dispositivo (FreeKiosk)",
    sectionTelemetryGpsLocation: "Posizione (GPS del dispositivo)",
    valueTelemetryNever: "Mai",
    valueTelemetryEmpty: "Nessun dato ancora",
    fieldHouse: "Struttura",
    valueUnbound: "Non associato",
    valueNotPaired: "Non collegato",
    valueUnassigned: "Non assegnato",
    menuRegenerateCredentials: "Rigenera credenziali",
    menuRevokeDevice: "Revoca credenziali",
    menuReactivateDevice: "Riattiva credenziali",
    menuNotes: "Note",
    menuManagePresences: "Gestisci ospiti",
    menuOtherInfo: "Altre informazioni",
    changeRoomTitle: "Cambia stanza",
    renameDeviceTitle: "Cambia stanza",
    roomNamePlaceholder: "Nome stanza",
    roomNameEmpty: "Il nome stanza non può essere vuoto",
    editGoogleAccountTitle: "Modifica account Google",
    telemetryBattery: "Batteria",
    telemetryWifi: "Segnale WiFi",
    telemetryAudio: "Volume audio",
    telemetryStorage: "Archivio usato",
    telemetryMemory: "RAM usata",
    telemetryUnavailable: "-",
    telemetryDataAge: "Dati di {{age}}",
  },
  createModal: {
    titleCreate: "Crea nuovo dispositivo",
    titleCreated: "Dispositivo creato!",
    hardwareIdLabel: "ID hardware (S/N o IMEI)",
    hardwareIdPlaceholder: "es. 359881234567890",
    hardwareIdRequired: "Inserisci un ID hardware (S/N o IMEI)",
    googleAccountLabel: "Account Google",
    googleAccountPlaceholder: "es. tablet@azienda.com",
    googleAccountRequired: "Inserisci l'email dell'account Google",
    roomNameLabel: "Stanza (facoltativo)",
    roomNamePlaceholder: "es. 231H",
    presetSelectorTitle: "Scegli un preset di dispositivo",
    presetsEmpty:
      "Nessun preset trovato. Puoi crearne uno dalla pagina dei preset di dispositivo oppure usare la modalità manuale qui sotto.",
    presetCardSpecs: 'Android {{version}} • {{resolution}} • {{inches}}"',
    presetRequired:
      "Seleziona un preset di dispositivo o passa alla modalità manuale",
    manualToggle: "Inserisci i dettagli hardware manualmente",
    brandPlaceholder: "es. Samsung",
    androidVersionLabel: "Versione Android",
    androidVersionPlaceholder: "es. 14",
    resolutionLabel: "Risoluzione display",
    resolutionPlaceholder: "es. 1920x1200",
    inchesLabel: "Pollici display",
    inchesPlaceholder: "es. 10.1",
    inchesInvalid: "I pollici del display devono essere un numero valido",
    submit: "Crea dispositivo",
    successTitle: "Dispositivo creato con successo!",
    successDescription:
      "Usa queste credenziali per accedere dal tablet. Non verranno mostrate di nuovo.",
    deviceNameLabel: "Stanza",
    modelLabel: "Modello",
    modelPlaceholder: "es. Tab A9",
    kioskCodeLabel: "Codice dispositivo",
    passwordLabel: "Password",
    qrHelp:
      "Scansiona questo QR dalla schermata di login del tablet per inserire automaticamente le credenziali.",
    importantLabel: "Importante:",
    importantDescription:
      "Salva ora queste credenziali. Chiunque scansioni il QR potrà accedere finché non rigeneri la password.",
  },
  presets: {
    validationRequired: "Tutti i campi sono obbligatori",
    validationDisplayInches:
      "I pollici del display devono essere un numero valido maggiore di zero",
    created: "Preset creato",
    updated: "Preset aggiornato",
    deleted: "Preset eliminato",
    deleteConfirm: "Eliminare il preset «{{name}}»?",
    brandPlaceholder: "Marca (es. TCL)",
    modelPlaceholder: "Modello (es. TAB 10L)",
    androidVersionPlaceholder: "Versione Android (es. 15)",
    resolutionPlaceholder: "Risoluzione (es. 800x1280)",
    inchesPlaceholder: "Pollici (es. 10.1)",
    save: "Salva preset",
    add: "Aggiungi preset",
    colModel: "Modello",
    colAndroid: "Android",
    colResolution: "Risoluzione",
    colInches: "Pollici",
    inchesValue: "{{inches}}″",
    colActions: "Azioni",
    empty: "Nessun preset ancora.",
    editTitle: "Modifica preset",
    deleteTitle: "Elimina preset",
  },
} as const;
